import Banner from 'components/Banner';
import GradientText from 'components/GradientText';
import NewsCards from 'components/NewsCards';
import TagsFilter from 'components/TagsFilter';
import image from 'images/news-banner.jpg';
import './styles.scss';
import { Button } from 'components/buttons/Button/Button';

const News = () => (
    <>
        <Banner title="Research, News & Events" image={image} buttonText="Subscribe for a newsletter" />

        <section className="container">
            <div className="inner-container">
                <div className="news-heading">
                    <GradientText size="small">
                        <div className="max-width-760">
                            We're constantly <em>publishing fresh news and research</em>, that will help expand your
                            knowledge of the current <em>challenges in the agricultural industry</em>.
                        </div>
                    </GradientText>
                    <TagsFilter />
                </div>
                <NewsCards />
                <Button type="show-more" className="full-width">
                    SHOW MORE
                </Button>
            </div>
        </section>
    </>
);

export default News;
